// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hk-6";
export var emphasizeQuantity = "_hk-3";
export var flatBottomCorners = "_hk-5";
export var productImage = "_hk-0";
export var quantityContainer = "_hk-2";
export var tooltip = "_hk-1";
export var wrapAndEllipsesOverflow = "_hk-4";